import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { SmsMessageDto } from '../models/sms-message.dto';
import { environment } from '../../environments/environment';
import { SmsMessageListDto } from '../models/sms-message-list.dto';
import { BeneficiaryPhoneContactDto } from '../models/beneficiary-phone-contact.dto';

@Injectable({
  providedIn: 'root',
})
export class SmsService {
  constructor(private readonly api: ApiService) {}

  public async sendSms(message: SmsMessageDto): Promise<void> {
    return this.api.post<void, SmsMessageDto>(environment.api.sms + '/send', message);
  }
  public async sendSmsList(message: SmsMessageListDto): Promise<BeneficiaryPhoneContactDto[]> {
    return this.api.post<BeneficiaryPhoneContactDto[], SmsMessageListDto>(environment.api.sms + '/send/list', message);
  }
}
